(function () {
  function patch() {
    var MobileSliderule = customElements.get('mobile-sliderule');
    if (!MobileSliderule || MobileSliderule.__accordionPatched) return;

    MobileSliderule.prototype.showSliderule = function () {
      this.classList.toggle('is-accordion-open');
      var expanded = this.classList.contains('is-accordion-open');
      if (this.trigger) this.trigger.setAttribute('aria-expanded', expanded);
    };

    MobileSliderule.prototype.hideSliderule = function () {
      this.classList.remove('is-accordion-open');
      if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
    };

    MobileSliderule.prototype.closeSliderule = function () {
      this.classList.remove('is-accordion-open');
      if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
    };

    MobileSliderule.__accordionPatched = true;
  }

  // Split tap targets: tapping the title text navigates to the collection (if it has a real link),
  // tapping the chevron icon only expands/collapses the sub-items. Mirrors Modera's mobile menu.
  function patchTitleNavigation() {
    if (window.__kaellinMenuTitleNavPatched) return;
    window.__kaellinMenuTitleNavPatched = true;

    document.addEventListener('click', function (event) {
      var chevron = event.target.closest('.sliderule__chevron--right');
      var slideruleEl = event.target.closest('mobile-sliderule');
      if (!slideruleEl || !slideruleEl.closest('.mobile-menu')) return;

      // Click landed on the chevron: let the normal toggle behaviour run.
      if (chevron) return;

      // Click landed on the title/row itself (not the chevron): try to navigate.
      var trigger = slideruleEl.querySelector(':scope > .sliderow');
      if (!trigger || !trigger.contains(event.target)) return;

      var backLink = slideruleEl.querySelector('.sliderow--back a.sliderow__title[href]');
      if (backLink && backLink.getAttribute('href') && backLink.getAttribute('href') !== '#') {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.href = backLink.getAttribute('href');
      }
      // If there's no real link (pure grouping label), do nothing extra — let the default toggle happen.
    }, true);
  }

  function init() {
    patch();
    patchTitleNavigation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
